<template>
  <div>
    <b-loading :is-full-page="true" :active="loading"></b-loading>
    <div class="container has-margin-top-30">
      <div class="columns is-vcentered">
        <div class="column is-8 is-offset-2">
          <div class="flex-card light-bordered light-raised">
            <div class="card-body has-text-centered">
              <h2 class="title">You've been added to the waiting list.</h2>
              <p>
                You'll receive a confirmation email once you've been added to
                the event roster.
              </p>
              <div class="has-text-centered has-margin-top-15">
                <div class="is-block has-text-centered">
                  <router-link :to="{name: 'Home'}">
                    Go Home
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';

export default {
  data() {
    return {
      loading: true,
      entry: null
    };
  },
  computed: {
    ...mapGetters(['event'])
  },
  created() {
    this.getEvent(this.$route.params.id).then(() => {
      this.loading = false;
    });
  },
  methods: {
    ...mapActions(['getEvent'])
  }
};
</script>
